import { createRoute } from '@tanstack/react-router'
import { Route as appLayoutRoute } from '../layout'

export const Route = createRoute({
  getParentRoute: () => appLayoutRoute,
  path: '/learn/articles/$slug',
}).lazy(() => import('./articles.$slug.lazy').then((d) => d.Route))
